// extracted by mini-css-extract-plugin
export default {"control":"control_control__6tbWv","button":"control_button__sL6H-"};